/* eslint max-classes-per-file: "off" */
import { transitionEndEventName } from './utility';

class FoldingMenu {
  constructor(element) {
    this.$parent = $(element).filter('._parent');
    this.$child = this.$parent.find('._child');
    this.isAnimate = false;
    this.storeHeight = null;

    if (!this.$parent.hasClass('_open') && !this.$parent.hasClass('_close')) {
      this.$parent.addClass('_close');
    }
  }

  active() {
    if (this.$parent.hasClass('_close')) {
      this.$child.css('display', '');
    }

    this.$child.on(`${transitionEndEventName.event}.foldingMenu`, () => {
      if (this.$parent.hasClass('_close')) {
        this.$child.css('display', '');
      }
      this.$child.css('height', '');
      this.isAnimate = false;
    });

    this.$parent.on('click.foldingMenu', () => {
      let elementHeight;

      if (this.isAnimate) {
        this.$child[0].style.height = this.$parent.hasClass('_close')
          ? `${this.storeHeight}px`
          : 0;
      } else {
        if (this.$parent.hasClass('_close')) {
          this.$child.css('display', 'block');
          elementHeight = this.$child[0].getBoundingClientRect().height;
          this.$child[0].style.height = 0;
          // eslint-disable-next-line no-unused-expressions
          this.$child[0].offsetHeight; // reflow
          this.$child[0].style.height = `${elementHeight}px`;
        } else {
          elementHeight = this.$child[0].getBoundingClientRect().height;
          this.$child[0].style.height = `${elementHeight}px`;
          // eslint-disable-next-line no-unused-expressions
          this.$child[0].offsetHeight; // reflow
          this.$child[0].style.height = 0;
        }
        this.storeHeight = elementHeight;
      }
      this.$parent.toggleClass('_open _close');
      this.isAnimate = true;
    });
  }

  inactive() {
    this.$parent.off('click.foldingMenu');
    this.$child.off(`${transitionEndEventName.event}.foldingMenu`);
    if (this.$parent.hasClass('_open')) {
      this.$parent.toggleClass('_open _close');
    }
    this.$child.css({
      display: '',
      height: '',
    });
    this.isAnimate = false;
  }
}

class Accordion {
  constructor(buttonElement, bodyElement) {
    this.$button = $(buttonElement);
    this.$body = $(bodyElement);
    this.isAnimate = false;
    this.storeHeight = null;
  }

  active() {
    if (this.$button.hasClass('_close')) {
      this.$body.hide();
    }

    this.$body.on(`${transitionEndEventName.event}.accordion`, () => {
      if (this.$button.hasClass('_close')) {
        this.$body.hide();
      }
      this.$body.css('height', '');
      this.isAnimate = false;
    });

    this.$button.on('click.accordion', event => {
      let elementHeight;

      event.preventDefault();

      if (this.isAnimate) {
        this.$body[0].style.height = this.$button.hasClass('_close')
          ? `${this.storeHeight}px`
          : 0;
      } else {
        if (this.$button.hasClass('_close')) {
          this.$body.css('display', 'block');
          elementHeight = this.$body[0].getBoundingClientRect().height;
          this.$body[0].style.height = 0;
          // eslint-disable-next-line no-unused-expressions
          this.$body[0].offsetHeight; // reflow
          this.$body[0].style.height = `${elementHeight}px`;
        } else {
          elementHeight = this.$body[0].getBoundingClientRect().height;
          this.$body[0].style.height = `${elementHeight}px`;
          // eslint-disable-next-line no-unused-expressions
          this.$body[0].offsetHeight; // reflow
          this.$body[0].style.height = 0;
        }
        this.storeHeight = elementHeight;
      }
      this.$button.toggleClass('_open _close');
      this.$body.toggleClass('_open _close');
      this.isAnimate = true;
    });
  }

  inactive() {
    this.$button.off('click.accordion');
    this.$body.off(`${transitionEndEventName.event}.accordion`);
    if (this.$button.hasClass('_open')) {
      this.$button.toggleClass('_open _close');
      this.$body.toggleClass('_open _close');
    }
    this.$body.css({
      display: '',
      height: '',
    });
    this.isAnimate = false;
  }
}

class ExclusiveButton {
  constructor(elementList) {
    this.elementList = elementList;
    this.scrollLastDate = 0;
  }

  static toggleState(element) {
    if (element.body.classList.contains('_open')) {
      element.button.classList.remove('_open');
      element.button.classList.add('_close');
      element.body.classList.remove('_open');
      element.body.classList.add('_close');
    } else {
      element.button.classList.remove('_close');
      element.button.classList.add('_open');
      element.body.classList.remove('_close');
      element.body.classList.add('_open');
    }
  }

  clickHandler(event) {
    event.preventDefault();

    if (event.currentTarget.classList.contains('_close')) {
      this.elementList.forEach(element => {
        if (
          element.button === event.currentTarget ||
          element.button.classList.contains('_open')
        ) {
          ExclusiveButton.toggleState(element);
        }
      });
    } else {
      ExclusiveButton.toggleState(
        this.elementList.find(
          element => element.button === event.currentTarget,
        ),
      );
    }
  }

  scrollHandler() {
    const nowDate = Date.now();

    if (this.scrollLastDate + 1000 < nowDate) {
      this.scrollLastDate = nowDate;
      this.elementList.forEach(element => {
        if (element.autoClose && element.button.classList.contains('_open')) {
          ExclusiveButton.toggleState(element);
        }
      });
    }
  }

  active() {
    this.elementList.forEach(element => {
      $(element.button).on(
        'click.exclusiveButton',
        this.clickHandler.bind(this),
      );
    });

    $(window).on('scroll.exclusiveButton', this.scrollHandler.bind(this));
  }

  inactive() {
    this.elementList.forEach(element => {
      $(element.button).off('click.exclusiveButton');
      $(window).off('scroll.exclusiveButton');
      if (element.button.classList.contains('_open')) {
        ExclusiveButton.toggleState(element);
      }
    });
  }
}

export default function headerMenu() {
  const $header = document.querySelectorAll('.l-header');
  const $headerMenu = document.querySelectorAll('.js-hamburger');
  const $button = document.querySelectorAll('.js-hamburger button');
  const $gnavItem = document.querySelectorAll('.l-gnav__item');
  const headers = Array.prototype.slice.call($header, 0);
  const headerButtons = Array.prototype.slice.call($headerMenu, 0);
  const buttons = Array.prototype.slice.call($button, 0);
  const gnavItems = Array.prototype.slice.call($gnavItem, 0);
  const mqlMenu = window.matchMedia('screen and (max-width: 980px)');
  const accordionItems = [];
  const searchButtonElement = $header[0].querySelector('.l-header__search');
  const searchBodyElement = $header[0].querySelector(
    '.l-header__searchContents',
  );
  const searchAccordion = new Accordion(searchButtonElement, searchBodyElement);
  const langButtonElement = $header[0].querySelector('.l-header__lang');
  const langBodyElement = $header[0].querySelector('.l-header__langSelect');
  const langAccordion = new Accordion(langButtonElement, langBodyElement);
  const exclusiveButton = new ExclusiveButton([
    {
      button: searchButtonElement,
      body: searchBodyElement,
      autoClose: false,
    },
    {
      button: langButtonElement,
      body: langBodyElement,
      autoClose: true,
    },
  ]);

  headerButtons.forEach(elem => {
    elem.addEventListener(
      'click',
      e => {
        e.preventDefault();
        e.stopPropagation();
        buttons.forEach(button => {
          button.classList.toggle('is-active');
        }, true);
        headers.forEach(header => {
          header.classList.toggle('_close');
          header.classList.toggle('_open');
        }, true);
      },
      true,
    );
  });

  gnavItems.forEach(elem => {
    accordionItems.push(new FoldingMenu(elem));
  });

  function checkBreakPoint(mql) {
    if (mql.matches) {
      exclusiveButton.inactive();
      searchAccordion.active();
      langAccordion.active();
      accordionItems.forEach(element => {
        element.active();
      });
    } else {
      exclusiveButton.active();
      searchAccordion.inactive();
      langAccordion.inactive();
      accordionItems.forEach(element => {
        element.inactive();
      });
    }
  }
  mqlMenu.addListener(checkBreakPoint);
  checkBreakPoint(mqlMenu);
}
